import AdminLotGroupDetail from './AdminLotGroupDetail'
export default AdminLotGroupDetail
